// extracted by mini-css-extract-plugin
export default {"participantAvatar":"ParticipantsList-module__participantAvatar__SrzgaHu","participantLimitNotice":"ParticipantsList-module__participantLimitNotice__h_iO98V"};